export default class Environment {
  private static env = process.env.REACT_APP_ENV;

  private static url = process.env.REACT_APP_API_URL;

  private static front_url = process.env.REACT_APP_FRONT_URL;

  private static sca_url = process.env.REACT_APP_SCA_URL!;

  private static file_url = process.env.REACT_APP_FILE_URL;

  private static sca_client_id = process.env.REACT_APP_SCA_CLIENT_ID!;

  private static sca_pwd = process.env.REACT_APP_PWD!;

  private static sca_client_auth_scope = process.env.REACT_APP_SCA_CLIENT_AUTH_SCOPE!;

  private static sca_redirect_url = Environment.front_url + '/login/sca';

  private static login_unico_url = process.env.REACT_APP_LOGIN_UNICO_URL;

  private static login_unico_redirect_url = Environment.front_url + '/login/unico';

  private static login_unico_client_id = process.env.REACT_APP_LOGIN_UNICO_CLIENT_ID;

  private static login_unico_client_auth_scope =
    process.env.REACT_APP_LOGIN_UNICO_CLIENT_AUTH_SCOPE;

  private static login_unico_user_confiabilidade_validas =
    process.env.REACT_APP_LOGIN_UNICO_USER_CONFIABILIDADES_VALIDAS!;

  private static login_unico_code_challenge = process.env.REACT_APP_LOGIN_UNICO_CODE_CHALLENGE;

  private static versao = 'v1.0';

  private static dev_url = 'https://tro-dev.srvs.antt.gov.br/api';

  private static nome_sistema = process.env.REACT_APP_NAME;

  private static versao_sistema = process.env.REACT_APP_VERSION;

  private static recaptcha_site_key = process.env.REACT_APP_SITE_KEY;

  private static show_captcha = process.env.REACT_APP_SHOW_CAPTCHA;

  public static getVersao() {
    return this.versao;
  }

  public static getEnv() {
    return this.env;
  }

  public static getUrl() {
    return this.url;
  }

  public static getScaUrl() {
    return this.sca_url;
  }

  public static getScaClientId() {
    return this.sca_client_id;
  }

  public static getScaPwd() {
    return this.sca_pwd;
  }

  public static getScaClientAuthScope() {
    return this.sca_client_auth_scope;
  }

  public static getFrontUrl(): string {
    return !this.front_url ? '' : this.front_url;
  }

  public static getLoginUnicoUrl() {
    return this.login_unico_url;
  }

  public static getLoginUnicoClientId() {
    return this.login_unico_client_id;
  }

  public static getLoginUnicoClientAuthScope() {
    return this.login_unico_client_auth_scope;
  }

  public static getLoginUnicoUserConfiabilidadeValidas() {
    return this.login_unico_user_confiabilidade_validas;
  }

  public static getScaRedirectUrl() {
    return this.sca_redirect_url;
  }

  public static getLoginUnicoRedirectUrl() {
    return this.login_unico_redirect_url;
  }

  public static getLoginUnicoCodeChallenge() {
    return this.login_unico_code_challenge;
  }


  public static getDevUrl(): string {
    return this.dev_url;
  }

  public static getNomeSistema() {
    return this.nome_sistema;
  }

  public static getVersaoSistema() {
    return this.versao_sistema;
  }

  public static getFileUrl() {
    return this.file_url;
  }

  public static getRecaptchaSiteKey(): any {
    return this.recaptcha_site_key;
  }


  public static getShowCaptcha(): any {
    return this.show_captcha == 'true';
  }
}
